import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { MatIconModule } from '@angular/material/icon';
import { IsDatePipeModule } from 'ngx-date-fns';
import { CalcTableTypeComponent } from './calc-table-type.component';
import { InputFieldTypeModule } from '../input-field-type/input-field-type.module';
import {
  AvatarModule,
  MatTooltipAddonsDirective,
} from '@lockton-apps/shared/ui/lui';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LetDirective } from '@ngrx/component';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';
import { CalcTableRowsPipe } from './pipes/calc-table-rows.pipe';
import {
  CastArrayPipe,
  CloneDeepPipe,
  TailPipe,
} from '@lockton-apps/shared/util/ng-lodash';

@NgModule({
  declarations: [CalcTableTypeComponent, CalcTableRowsPipe],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
    AvatarModule,
    MatTooltipModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'calc-table',
          component: CalcTableTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
    MatIconModule,
    IsDatePipeModule,
    InputFieldTypeModule,
    NgxMaskPipe,
    MatTooltipAddonsDirective,
    LetDirective,
    CastObservablePipe,
    TailPipe,
    CloneDeepPipe,
    CastArrayPipe,
  ],
})
export class CalcTableTypeModule {}
